import React from "react";

const I360Icon: () => JSX.Element = () => {
  return <div className="text-sm font-bold">360</div>;
};

export default I360Icon;
